import { useTranslation } from "react-i18next";
import React from "react";
import AtencionIMG from "../../assets/app/OurServicesSection/ATENCION-AL-CLIENTE.png";
import eComerceIMG from "../../assets/app/OurServicesSection/E-COMMERCE-1.png";
import SaludIMG from "../../assets/app/OurServicesSection/SALUD-4.png";
import RRHHIMG from "../../assets/app/OurServicesSection/RRHH-4.png";
import EducacionIMG from "../../assets/app/OurServicesSection/EDUCACION-2.png";
import PyMEsIMG from "../../assets/app/OurServicesSection/PYMES-3.png";
import OurServicesCard from "./OurServicesCard";

import "../../styles/app/OurServiceSection.css";

const OurServiceSection: React.FC = () => {
  const { t } = useTranslation();

  const props = [
    {
      src: AtencionIMG,
      title: t("ourServices.services.0.title"),
      desc: t("ourServices.services.0.description"),
      linkTo: "/logistic",
    },
    {
      src: eComerceIMG,
      title: t("ourServices.services.1.title"),
      desc: t("ourServices.services.1.description"),
    },
    {
      src: SaludIMG,
      title: t("ourServices.services.2.title"),
      desc: t("ourServices.services.2.description"),
    },
    {
      src: RRHHIMG,
      title: t("ourServices.services.3.title"),
      desc: t("ourServices.services.3.description"),
    },
    {
      src: EducacionIMG,
      title: t("ourServices.services.4.title"),
      desc: t("ourServices.services.4.description"),
    },
    {
      src: PyMEsIMG,
      title: t("ourServices.services.5.title"),
      desc: t("ourServices.services.5.description"),
    },
  ];

  return (
    <>
      <section id="services" className="our-services-section">
        <div className="our-services-heading">
          <h1 className="our-services-title">{t("ourServices.title")}</h1>
          <p className="our-services-desc">{t("ourServices.description")}</p>
        </div>
        <div className="our-services-grid">
          {props.map((p, index) => (
            <OurServicesCard
              key={index}
              src={p.src}
              title={p.title}
              desc={p.desc}
              linkTo={p.linkTo}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default OurServiceSection;
